import React from "react";
import Appbar from "../../components/Appbar";
import styled from "styled-components";
import ScrollTop from "../../components/ScrollTop";
import Footer from "../../components/Footer";
import TimelineComponent from "./components/Timeline"; 

const Body = styled.div`  
  min-height: 100vh;
  padding-top: 120px;

  @media all and (max-width: 768px) {
    & {
      padding-top: 64px;
    }
  }
`;


function AcompanhamentoPage(props) {
  return (
    <Body>
      <Appbar />
 
      <TimelineComponent {...props} />

      <Footer />
      <ScrollTop />
    </Body>
  );
}

export default AcompanhamentoPage;
